import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

function NotFound() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="App">
      <Helmet>
        <title>404 - Sayfa Bulunamadı | Tilki Otomasyon</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <Header />

      <main id="main-content" className="min-h-[60vh] flex items-center justify-center pt-24 pb-12 px-4 sm:px-6">
        <div className="text-center max-w-xl mx-auto">
          <p className="text-6xl sm:text-7xl lg:text-8xl font-bold text-brand-600 font-poppins leading-none">404</p>
          <h1 className="mt-4 text-2xl sm:text-3xl lg:text-4xl font-bold text-ink font-poppins">Sayfa bulunamadı</h1>
          <p className="mt-4 text-base sm:text-lg text-ink-muted font-inter">
            Aradığınız sayfa mevcut değil. Taşınmış veya silinmiş olabilir.
          </p>
          <Link to="/" className="modern-btn-primary mt-8">
            Ana sayfaya dön
          </Link>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default NotFound;
